import { OverlayShellConfig } from "../../../shared/overlay-shell/overlay.models";

export const NEW_REPLACEMENT_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: false,
  width: "auto",
  height: "auto",
};
